import {Alarm, Info } from "@mui/icons-material"
import Page from "../../components/molecules/page"
import { ConsumerPriceListView } from "./ConsumerPriceList/consumerPriceListView"
import { TagsPage } from "./Tags/tagsPage"

export const SettingsPage = () => {
    // return <Page title={"Settings"} pageSections={[<ConsumerPriceListView  />]} />   

    return (
        <Page
            title={'Settings'}
            tabs={[
                {
                    name: 'Consumer list price',
                    icon: <Info />,
                    pageSections: [<ConsumerPriceListView />]
                },
                {
                    name: 'Tags',
                    icon: <Alarm />,
                    pageSections: [<TagsPage />]
                },
            ]}
        >
        </Page>
    )

}

